// extracted by mini-css-extract-plugin
export default {"scrollbarTrack":"CustomScrollbar_scrollbarTrack__v54o2","scrollbarThumb":"CustomScrollbar_scrollbarThumb__S6PxM"};